import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=45bfd837&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=45bfd837&prod&scoped=true&lang=less"
import style1 from "./ArticleList.vue?vue&type=style&index=1&id=45bfd837&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bfd837",
  null
  
)

export default component.exports